import React from 'react';
import ArtifactBlock from './ArtifactBlock';
import '../../styles/global.css';
import { useBrand } from '../../../theme/brand';

// Standalone read-only report behind a public share link. No sidebar, no
// composer, no session — the holder of a public link is a viewer, not a
// participant, so there is deliberately nothing here that can send a message
// or spend the owner's credits.

const st = {
    page: { minHeight: '100vh', background: '#eef2f7', padding: '32px 16px', fontFamily: 'Inter, system-ui, sans-serif' },
    shell: { maxWidth: '860px', margin: '0 auto', display: 'flex', flexDirection: 'column', gap: '14px' },
    header: { display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: '12px', flexWrap: 'wrap' },
    brand: { fontSize: '13px', fontWeight: 800, color: 'var(--cux-ink, #132848)', letterSpacing: '0.02em' },
    title: { fontSize: '20px', fontWeight: 800, color: '#0f172a', margin: 0 },
    expiry: { fontSize: '11.5px', color: '#64748b', margin: 0 },
    card: { background: '#fff', border: '1px solid #d3ddea', borderRadius: '16px', padding: '18px' },
    empty: { fontSize: '13px', color: '#475569', margin: 0 },
};

function expiryLabel(expiresAt) {
    if (!expiresAt) return null;
    const d = new Date(expiresAt);
    if (Number.isNaN(d.getTime())) return null;
    return `This link expires at ${d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} on ${d.toLocaleDateString()}`;
}

export default function SharedReportView({ title, blocks = [], expiresAt }) {
    const brand = useBrand();
    const ordered = [...blocks].sort((a, b) => (a.position || 0) - (b.position || 0));
    const expiry = expiryLabel(expiresAt);
    return (
        <div style={st.page}>
            <div style={st.shell}>
                <div style={st.header}>
                    <div>
                        <span style={st.brand}>{brand.name}</span>
                        <h1 style={st.title}>{title || 'Analysis report'}</h1>
                    </div>
                    {expiry && <p style={st.expiry}>{expiry}</p>}
                </div>
                <div style={st.card}>
                    {ordered.length === 0 ? (
                        <p style={st.empty}>This report has no blocks yet.</p>
                    ) : ordered.map((b, i) => (
                        <ArtifactBlock
                            key={b.id}
                            block={b}
                            readOnly
                            isFirst={i === 0}
                            isLast={i === ordered.length - 1}
                            onEdit={() => {}}
                            onMove={() => {}}
                            onDelete={() => {}}
                            onAskAgent={() => {}}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}
